import { useEffect } from 'react';
import { useGameStore } from '../store/gameStore';

export const useGameTimer = () => {
    const gamePhase = useGameStore((state) => state.gamePhase);
    const winner = useGameStore((state) => state.winner);
    const gameStartTime = useGameStore((state) => state.gameStartTime);
    const currentTeam = useGameStore((state) => state.currentTeam);
    const setElapsedTime = useGameStore((state) => state.setElapsedTime);
    const resetTimer = useGameStore((state) => state.resetTimer);

    // Timer effect to update elapsed time for current turn
    useEffect(() => {
        let interval: NodeJS.Timeout | null = null;

        if (gamePhase === 'playing' && !winner && gameStartTime) {
            interval = setInterval(() => {
                setElapsedTime(Math.floor((Date.now() - gameStartTime) / 1000));
            }, 1000);
        }

        return () => {
            if (interval) clearInterval(interval);
        };
    }, [gamePhase, winner, gameStartTime, setElapsedTime]);

    // Reset timer whenever the turn changes
    useEffect(() => {
        if (gamePhase === 'playing' && !winner) {
            resetTimer();
        }
    }, [currentTeam, gamePhase, winner, resetTimer]);
};
